import { render } from "./PasswordPolicyHints.vue?vue&type=template&id=3b8fbcda&scoped=true"
import script from "./PasswordPolicyHints.vue?vue&type=script&lang=js"
export * from "./PasswordPolicyHints.vue?vue&type=script&lang=js"

import "./PasswordPolicyHints.vue?vue&type=style&index=0&id=3b8fbcda&lang=scss&scoped=true"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8fbcda"]])

export default __exports__